import { EButtonColorTypes, EButtonTypes } from '@shared/components/button/button.enums';
import { EInputTypes } from '@shared/components/custom-input/custom-input.enums';

export const CUserProfileConfig = {
  buttons: {
    refreshPage: {
      type: EButtonTypes.Medium,
      colorType: EButtonColorTypes.Fill,
    },
    uploadPicture: {
      type: EButtonTypes.Small,
      colorType: EButtonColorTypes.Fill,
    },
    submitUploadPicture: {
      type: EButtonTypes.Medium,
      colorType: EButtonColorTypes.Fill,
    },
    logOut: {
      type: EButtonTypes.LogOut,
    },
    delete: {
      type: EButtonTypes.Small,
      colorType: EButtonColorTypes.Empty,
    },
    deletePicture: {
      type: EButtonTypes.Small,
      colorType: EButtonColorTypes.Empty,
    },
    saveChanges: {
      type: EButtonTypes.Medium,
      colorType: EButtonColorTypes.Fill,
    },
    save: {
      type: EButtonTypes.Medium,
      colorType: EButtonColorTypes.Fill,
    },
    setNewPassword: {
      type: EButtonTypes.Medium,
      colorType: EButtonColorTypes.Fill,
    },
    paymentUpdate: {
      type: EButtonTypes.Medium,
      colorType: EButtonColorTypes.Fill,
    },
    cancel: {
      type: EButtonTypes.Medium,
      colorType: EButtonColorTypes.Empty,
    },
  },
  inputs: {
    name: {
      type: EInputTypes.Text,
    },
    lastName: {
      type: EInputTypes.Text,
    },
    email: {
      type: EInputTypes.Email,
    },
    newPassword: {
      type: EInputTypes.Password,
    },
    repeatNewPassword: {
      type: EInputTypes.Password,
    },
    paymentRadio: {
      type: EInputTypes.Radio,
      name: 'payment',
    },
  },
};
